import React, { FC } from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  buttonsWrap: {
    '&div': {
      width: 300,
    },

    '& button': {
      backgroundColor: 'transparent',
      color: theme.palette.secondary.main,
      borderColor: theme.palette.secondary.main,
      textTransform: 'none',
      width: 150,
      height: 40,
      borderRadius: 8,
    },

    '& .Mui-selected': {
      backgroundColor: theme.palette.secondary.main,
      color: `${theme.palette.primary.main} !important`,
      '&:hover': {
        color: theme.palette.primary.main,
        background: theme.palette.secondary.light,
      },
      '&.MuiButton-contained.Mui-disabled': {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.secondary.main,
        opacity: 0.6,
      },
    },
  },
}))

interface IToggleButtons {
  getSelectedRole: (value: string) => void
}

export const ToggleButtons: FC<IToggleButtons> = ({ getSelectedRole }) => {
  const classes = useStyles()

  const [role, setRole] = React.useState('company')

  const handleChange = (event: React.MouseEvent<HTMLElement>, newRole: string | null) => {
    if (newRole !== null) {
      setRole(newRole)
      getSelectedRole(newRole)
    }
  }

  return (
    <ToggleButtonGroup value={role} exclusive onChange={handleChange} className={classes.buttonsWrap}>
      <ToggleButton value="company">Company</ToggleButton>
      <ToggleButton value="executor">Executor</ToggleButton>
    </ToggleButtonGroup>
  )
}
